if (checkIfExists('.product-options')) {
  $('.add-to-cart .product-options .color').on('click', function(){
    $('.add-to-cart .product-options .color').removeClass('active');
    $(this).addClass('active');

    var title = $(this).data('title');
    var price = $(this).data('price');
    var price_old = $(this).data('price-old');

    var price_eur = $(this).data('price-eur');
    var price_old_eur = $(this).data('price-old-eur');

    $('.price-old-eur span').html(price_old_eur);
    $('.price-wrapper .last-price-eur').html(price_eur);


    $('.price-wrapper .last-price').html(price)
    $('.add-to-cart .product-options .selected-option').html('('+title+')')
  })

  $('.add-to-cart .product-options .option').on('click', function(){
    $('.add-to-cart .product-options .option').removeClass('active');
    $(this).addClass('active');

    var title = $(this).data('title');
    var price = $(this).data('price');
    var price_old = $(this).data('price-old');

    var price_eur = $(this).data('price-eur');
    var price_old_eur = $(this).data('price-old-eur');

    $('.price-old span').html(price_old);
    $('.price-wrapper .last-price').html(price);

    $('.price-old-eur span').html(price_old_eur);
    $('.price-wrapper .last-price-eur').html(price_eur);


    $('.add-to-cart .product-options .selected-option').html('('+title+')')
  })

  $('.add-to-cart .product-options .photo').on('click', function(){
    $('.add-to-cart .product-options .photo').removeClass('active');
    $(this).addClass('active');

    var title = $(this).data('title');
    var price = $(this).data('price');
    var price_old = $(this).data('price-old');

    var price_eur = $(this).data('price-eur');
    var price_old_eur = $(this).data('price-old-eur');

    $('.price-old span').html(price_old);
    $('.price-wrapper .last-price').html(price);

    $('.price-old-eur span').html(price_old_eur);
    $('.price-wrapper .last-price-eur').html(price_eur);

    $('.add-to-cart .product-options .selected-option').html('('+title+')')
  })
}


if (checkIfExists('.product-quick-options')) {
  $('.product-quick-options .color').on('click', function(){
    $('.product-quick-options .color').removeClass('active');
    $(this).addClass('active');

    var title = $(this).data('title');
    var price = $(this).data('price');
    var price_eur = $(this).data('price-eur');

    var price_old = $(this).data('price-old');
    var quantity = $('.quick-order select[name=quantity] option:selected').val();



    $('.price-old span').html(price_old);
    $('.quick-order-info .single-price').html(price);
    $('.quick-order-info .last-price').html(parseFloat(price * quantity).toFixed(2));

    $('.quick-order-info .single-price-eur').html(price_eur);
    $('.quick-order-info .last-price-eur').html(parseFloat(price_eur * quantity).toFixed(2));

    $('.product-quick-options .selected-option').html('('+title+')')
  })

  $('.product-quick-options .option').on('click', function(){
    $('.product-quick-options .option').removeClass('active');
    $(this).addClass('active');

    var title = $(this).data('title');
    var price = $(this).data('price');
    var price_old = $(this).data('price-old');
    var quantity = $('.quick-order select[name=quantity] option:selected').val();

    var price_eur = $(this).data('price-eur');

    $('.price-old span').html(price_old);
    $('.quick-order-info .single-price').html(price);


    $('.quick-order-info .single-price-eur').html(price_eur);
    $('.quick-order-info .last-price-eur').html(parseFloat(price_eur * quantity).toFixed(2));

    $('.quick-order-info .last-price').html(parseFloat(price * quantity).toFixed(2))
    $('.product-quick-options .selected-option').html('('+title+')')
  })

  $('.product-quick-options .photo').on('click', function(){
    $('.product-quick-options .photo').removeClass('active');
    $(this).addClass('active');

    var title = $(this).data('title');
    var quantity = $('.quick-order select[name=quantity] option:selected').val();
    var price = $(this).data('price');
    var price_old = $(this).data('price-old');

    var price_eur = $(this).data('price-eur');

    $('.price-old span').html(price_old);
    $('.quick-order-info .single-price').html(price);
    $('.quick-order-info .last-price').html(parseFloat(price * quantity).toFixed(2))

    $('.quick-order-info .single-price-eur').html(price_eur);
    $('.quick-order-info .last-price-eur').html(parseFloat(price_eur * quantity).toFixed(2));


    $('.product-quick-options .selected-option').html('('+title+')')
  })

  $('.quick-order select[name=quantity]').on('change', function(){
    var price = parseFloat($('.quick-order-info .single-price').text()).toFixed(2);
    var price_eur = parseFloat($('.quick-order-info .single-price-eur').text()).toFixed(2);

    var quantity = $('.quick-order select[name=quantity] option:selected').val();
    $('.quick-order-info .last-price').html(parseFloat(price * quantity).toFixed(2));
    $('.quick-order-info .last-price-eur').html(parseFloat(price_eur * quantity).toFixed(2));
  });
}

if (checkIfExists('.product-detail')) {
  $('#myTab .nav-item:first .nav-link').addClass('active');
  $('#myTabContent .tab-pane:first').addClass('active show');
}
